import { useEffect, useState } from 'react';
import { fetchNotes } from '../services/api';
import {
  Container, Typography, Box, Paper
} from '@mui/material';

const Dashboard = () => {
  const [noteCount, setNoteCount] = useState(0);

  const loadNoteCount = async () => {
    try {
      const res = await fetchNotes('', '');
      setNoteCount(res.data?.length || 0);
    } catch (err) {
      console.error('Failed to fetch notes:', err);
    }
  };

  useEffect(() => {
    loadNoteCount();
  }, []);

  return (
    <Container>
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={4}>
        <Typography variant="h4">Dashboard</Typography>
        
      </Box>

      <Box mt={5} display="flex" gap={3} flexWrap="wrap">
        <Paper elevation={3} sx={{ padding: 3, minWidth: 200 }}>
          <Typography variant="h6" gutterBottom>
            Total Notes
          </Typography>
          <Typography variant="h4" color="primary">
            {noteCount}
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default Dashboard;
